/* 🤖 this file was generated by svg-to-ts */
export const DfIconEyeClosed16: {
  name: 'eye-closed-16';
  data: string;
} = {
  name: 'eye-closed-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m3.239 3.836-.94-1.129a1 1 0 0 1 1.414-1.414l9.996 12a1 1 0 1 1-1.414 1.415l-1.213-1.456c-1.007.499-2.03.748-3.069.748-2.628 0-5.161-1.595-7.6-4.785a2 2 0 0 1 0-2.43c.928-1.214 1.87-2.197 2.826-2.95zm6.479 7.778L8.348 9.97A2 2 0 0 1 6.125 7.3L4.757 5.658a4 4 0 0 0 4.96 5.955zM6.633 2.149A6.501 6.501 0 0 1 8.013 2c2.63 0 5.157 1.597 7.582 4.79a2 2 0 0 1 0 2.42c-.539.71-1.083 1.34-1.632 1.893l-2.014-2.46a4 4 0 0 0-3.798-4.64z" fill-rule="evenodd"/></svg>`
};
